
export default defineAppConfig({

  // App-specific config
  serviceName: 'auth'

  // Base app's config is merged in here.

})
